<template>
  <div class="dashboard">
  <b-overlay :show="!states.showMain" no-wrap fixed z-index="60" />
  <div class="text">
	<!-- <h1>{{ langText('easyOnboarding.mfa.title', true ) }}</h1> -->

  <p class="my-4 bigger-text" v-html="langText(states.mainScenario === 'b2b' ? 'primaryContactB2b.intro' : 'primaryContact.intro', true)" />

  <div v-show="!states.mainPage">
    <b-modal id="bp-modal" hide-header scrollable :centered="false" size="md" :visible="custIdModalbtn" @hide="custIdModalbtn = false" :hide-backdrop="backdropVisibility">
      <div class="text-right w-100">
        <b-icon-x-circle-fill variant="secondary" class="modal-icon-close" @click="custIdModalbtn = false" v-model="custIdModalbtn" />
      </div>
      <div class="text-center">
        <h2 class="my-3">Číslo adresáta nájdete na prvej strane faktúry:</h2>
      </div>
      <div class="d-flex justify-content-center mb-2">
        <img class="w-100" alt="kod adresata" src="../assets/img/kod_adresata.jpg"/>
      </div>
      <p class="pt-3 mb-2 lh-1 bp-help">Číslo adresáta nájdete aj v <strong class="magenta">Telekom appke</strong>. V <strong>spodnom menu</strong> prejdite do časti <strong>"Platby"</strong> → <strong>"História faktúr"</strong> → vyberte ľubovoľnú faktúru a zobrazte si <strong>detaily v časti "Viac informácií"</strong>.
      </p>
      <template #modal-footer>
        <button type="button" class="btn btn-secondary col px-3 py-2" @click.prevent="custIdModalbtn = false">Zavrieť okno</button>
      </template>        
    </b-modal>      
    <b-alert variant="info" show class="d-flex flex-wrap-0 align-items-center justify-content-start pt-3 pb-2">
    <div class="flex-grow-0 pl-0 pr-4">
      <b-icon-exclamation-triangle-fill variant="info" class="left-alert-icon"></b-icon-exclamation-triangle-fill>
    </div>
    <div class="flex-grow-1">
      <p class="font-weight-bold mb-0" v-text="langText('primaryContact.mainAlert.label', true)"></p>
      <span v-html="langText(states.mainScenario === 'b2b' ? 'primaryContact.mainAlertB2b.text' : 'primaryContact.mainAlert.text', true)" />
    </div>
  </b-alert>
  <h2 class="mt-5" ref="choicePlace" v-text="langText('primaryContact.choice.header', true)" />
  <p class="font-weight-bold mt-0" v-text="langText('primaryContact.choice.label', true)" v-show="states.choiceShown" />
  <ul class="nav mt-5 myw-nav" v-show="states.choiceShown">
    <li class="nav-item text-center" @click="changeScenario('b2c')">
      <a class="nav-link" :class="{ 'active': states.mainScenario === 'b2c' }">Pre vás</a>
    </li>
    <li class="nav-item text-center" @click="changeScenario('b2b')">
      <a class="nav-link" :class="{ 'active': states.mainScenario === 'b2b' }">Živnostníci a malé firmy</a>
    </li>
  </ul>
  <div class="mt-5 dyn-form pb-4">
    <b-alert variant="warning" :show="states.mainAlert.visible" class="d-flex flex-wrap-0 align-items-center justify-content-start pt-3 pb-2">
      <div class="flex-grow-0 pl-0 pr-4">
        <b-icon-exclamation-circle-fill variant="warning" class="left-alert-icon" />
      </div>
      <div class="flex-grow-1 mb-1" v-html="states.mainAlert.text" />
    </b-alert>

    <div class="input-wrapper position-relative mb-4" v-for="sInput in currForm" :key="sInput.name">
      <input
          type="text"
          class="input_text mb-1"
          required
          :class="{ error: sInput.isErr, 'empty': !sInput.isReadOnly  }"
          v-model="sInput.value"
          :id="sInput.name"
          :disabled="sInput.isReadOnly"
          @keyup="resetErr"
      />
      <label class="placeholder" :for="sInput.name" v-html="sInput.title" />
        <div class="error_message text-left small text-muted"
          :class="{ 'd-block': sInput.isErr }"
          v-text="sInput.errText">
        </div>

        <div :class="{ 'py-2': sInput.isErr }" class="position-relative" v-show="!sInput.isErr && sInput.name === 'bpn'">
          <div class="d-flex py-0 px-0 position-absolute" id="customer-id-modal-help">
            <span class="btn btn-link cpointer small" @click.prevent="custIdModalbtn = true">Kde nájdem číslo adresáta?</span>
          </div>
        </div>

    </div>
    <p class="mt-5 mb-3"><a href="/wiki/ostatne/osobne-udaje" target="disc" class="font-weight-bold" v-text="langText('primaryContact.gdpr.link', true)" /></p>
    <b-button variant="primary" size="lg" block class="text-uppercase" @click="sendData">{{ langText('primaryContact.verification.button', true) }}</b-button>
    </div>
  </div>
	<Actions v-if="states.mainPage && !mainScenarioIsResid" :states="states" :verifData="verifData" />
	<ResidActions v-if="states.mainPage && mainScenarioIsResid" :states="states" :verifData="verifData" />
  <p class="text-muted my-5 lh-18"><small v-html="langText('primaryContact.disclaimer', true)" /></p>
	</div>
</div>
</template>
<script>
import Actions from './actions'
import ResidActions from './ResidActions'
import allDefs from '@/assets/js/formDef'
import validatePersonalNr from '@/components/common'
import langTextMixin from '@/components/common/mixin'
export default {
  name: 'PrimaryContact',
  mixins: [ langTextMixin ],
  components: {
	  Actions, ResidActions
  },
  data() {
    return {
  	formDef: allDefs,
    states: {
      showMain: true, verifPages: true, mainPage: false,
      mainScenario: 'b2c', 
      mainAlert: { visible: false, text: ''},
      choiceShown: false
	},
	msg: 'Aktualizácia kontaktných údajov',
  formComponent: [],
	formError: "&nbsp;",
	verifData: {},
  urlObj: new URL(window.parent.location),
  childUrlObj: new URL(window.location),
  custIdModalbtn: false
    }
  },
  mounted: function() {
    $('.masterTooltip').tooltip({html: true})
    var query = this.urlObj.searchParams;
    var childQuery = this.childUrlObj.searchParams;
    var adresat = query.get('cisloAdresata') || query.get('billingCode');
    var regNo = query.get('ico') || query.get('regNumber');
    if (childQuery.get('customerType')) {
      const scenarioType = childQuery.get('customerType'); 
      this.states.mainScenario = scenarioType === 'b2b' ? scenarioType : 'b2c';   
    }
    if (childQuery.get('hideChoice') === null) {
      this.states.choiceShown = true;      
    }
    if (adresat !== null) {
      var thisBpn = _.filter(this.formDef.b2c, { name: 'bpn' })[0];
      if (typeof(adresat === 'string')) {
        adresat = adresat.replace(/ /g, '');
        if (adresat.length > 7) {
          thisBpn.value = adresat;  
          thisBpn.isReadOnly = true;  
        }
        window.parent.history.replaceState({}, null, this.urlObj.pathname);
      }
    }
    if (regNo !== null) {
      var thisRegNo= _.filter(this.formDef.b2b, { name: 'regNo' })[0];
      if (typeof(regNo === 'string')) {
        regNo = regNo.replace(/ /g, '');
        if (regNo.length > 3) {
          thisRegNo.value = regNo;  
          thisRegNo.isReadOnly = true;  
        }
        window.parent.history.replaceState({}, null, this.urlObj.pathname);
      }
    }
  },
  methods: {
    sendData: function() {
      var that = this 
      this.infoAlert = false, this.formError = '&nbsp;'
      this.states.mainAlert.visible = false;
      var formValid = true, verifData = {}
      _.each(this.currForm, function(v,k){
    	if ((v.name != 'surName') && (v.name != 'fName') && (v.name != 'primaryFName') && (v.name != 'primarySurName')) {
          v.value = (v.value).replace(/(\r\n|\n|\r| )/gm, '') 
        } else {
          v.value = (v.value).replace(/(\r\n|\n|\r)/gm, ''); 
        }
        switch (v.name) {
          case 'surName':        
          case 'fName':  
          case 'primaryFName':  
          case 'primarySurName':  
           if (v.value.length < 3) {
              formValid = false
              v.isErr = true
            } else {
              v.isErr = false
            }
          break;
          case 'personalId':     
            const persIDResult = validatePersonalNr(v.value);  
            if (persIDResult.res) {
              v.value = persIDResult.virgin;
              v.isErr = false
            } else {
              formValid = false;
              v.isErr = true
            }
          break;
          case 'regNo':        
            v.value = (String(v.value)).replace(/ /gm, '');
            if ((v.value.length < 7) || (v.value.length > 10) || (isNaN(v.value))) {
              formValid = false;
              v.isErr = true
            } else {
              v.isErr = false
            }
          break;
          case 'bpn':        
            if ((v.value.replace(/ /g, '').length < 8) || (v.value.replace(/ /g, '').length > 12)) {
              formValid = false;
              v.isErr = true
            } else {
			        v.value = v.value.replace(/ /g, '')
              v.isErr = false
            }
          break;
          case 'pid':        
            if ((v.value.replace(/ /g, '').length < 3) || (isNaN(v.value.replace(/ /g, '')))) {
              formValid = false;
              v.isErr = true
            } else {
			        v.value = v.value.replace(/ /g, '')
              v.isErr = false
            }
          break;
        }
        verifData[v.name] = that.htmlEscape(v.value)
	  })
      if (formValid) {
        this.states.showMain = false;
        verifData.scenario = this.states.mainScenario;
        this.$http.post(that.$store.state.validateCustSrc + "/validate", verifData)     
        .then(function(resp){
          that.verifData = {data: resp.data, code: resp.status, bpn: verifData.bpn }
          that.states.mainAlert.text = "&nbsp;"
          that.states.mainPage = true;
        })
        .catch(function(err) {
          that.states.mainAlert.visible = true;
          switch(err.response?.status) {
            case 429:
              that.states.mainAlert.text = "Aktivovala sa ochrana systému. Skúste znovu po uplynutí 15 minút."
              break;
            case 404:
              if (that.states.mainScenario === 'b2b') {
                that.states.mainAlert.text = "IČO nenájdené."
              } else {
                that.states.mainAlert.text = "Zadaný adresát nenájdený."
              }
              break;
            case 403:
              that.verifData = { data: err.response?.data, code: err.response?.status, bpn: verifData.bpn }
              if (err.response.data.message === 'deny_by_customer') {
                if (that.states.mainScenario === 'b2b') {
                  that.states.mainAlert.text = "Pre zvoleného zákazníka nie je možná zmena kontaktných údajov týmto spôsobom. Kontaktujte nás na linke 0800123500 alebo navštívte Telekom centrum."
                } else {
                  that.states.mainAlert.text = "Pre zvoleného zákazníka nie je možná zmena kontaktných údajov týmto spôsobom. Kontaktujte nás na linke 0800123456 alebo navštívte Telekom centrum."
                }
              } else {
                if (that.states.mainScenario === 'b2b') {
                  that.states.mainAlert.text = "Skontrolujte si prosím správnosť vami zadaných údajov (preklep, nesprávne IČO). Ak údaje zadávate správne, kontaktujte prosím našu Zákaznícku linku <span style='white-space: nowrap;'>0800 123 500</span> alebo navštívte ktorékoľvek Telekom Centrum za účelom overenia a aktualizácie vašich zákazníckych a kontaktných údajov v našom systéme."
                } else {
                  that.states.mainAlert.text = "Skontrolujte si prosím správnosť vami zadaných údajov (preklep, nesprávne rodné číslo). Ak údaje zadávate správne, kontaktujte prosím našu Zákaznícku linku <span style='white-space: nowrap;'>0800 123 456</span> alebo navštívte ktorékoľvek Telekom Centrum za účelom overenia a aktualizácie vašich zákazníckych a kontaktných údajov v našom systéme."
                }
              }
              break;
            default:
              that.states.mainAlert.text = "Pri overení nastala chyba, skúste neskôr."
          } 
        })
        .finally(function(){
          that.states.showMain = true
          setTimeout(() => {
            if (that.states.mainPage) {
              window.parent.scrollBy({
                top: 120 - window.parent.scrollY,
                left: 0,
                behavior: "smooth"
              })
            } else {
              that.$refs['choicePlace'].scrollIntoView({ behavior: "smooth" });
            }
          }, 350);
        })
      }
//
      // else { 
      //   that.states.verifPages = false
      //   that.states.mainPage = true
      //   that.verifData = {data: {}, code: {}, bpn: {} }
      //  }
//
    },

    changeScenario: function(ns) {
      if (this.states.mainScenario !== ns) {
        this.states.showMain = false;
        setTimeout(()=>{
          window.parent.location.href = ns === 'b2b' ? '/biznis/kontaktne-udaje' : '/kontaktne-udaje';
        }, 400)
        return;
      }
      this.states.mainScenario = ns;
      _.each(this.currForm, function(cf) {
        cf.isErr = false;
      })
      this.states.mainAlert.visible = false;
    },
    resetErr: function() {
      _.each(this.currForm, function(el1){
        if (el1.value.length > 0 && el1.value.length < 8) {
          el1.isErr = false;
        }
      })
    },

	validateMsisdn: function(cnr) {
	var tMsisdn = String(cnr).replace(/(\r\n|\n|\r| )/gm, "")
		, rtrn = false
		, tRtrn;
	if (tMsisdn.length >= 9) {
		tRtrn = tMsisdn.substring(tMsisdn.length - 9, tMsisdn.length);
	}
	else if (tMsisdn.length == 9) {
		tRtrn = tMsisdn;
	}
	if (($.isNumeric(tRtrn)) && (tRtrn.indexOf(0) != '0')) {
		if (tRtrn.substr(0,1) == 9) {
		rtrn = tRtrn;
		}
	}
	return rtrn;
	},
    htmlEscape: function (str) {
		return str.replace(/\&/g, '&amp;').replace(/\"/g, '&quot;').replace(/\'/g, '&#39;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;');
	}
  },
  computed: {
    currForm: function() {
      return this.formDef[this.states.mainScenario];
    },
    backdropVisibility: function() {
      return window.innerWidth > 900
    },
    mainScenarioIsResid: function() {
      return this.states.mainScenario === 'b2c'
    },
    spinnerState: function() {
      return this.$store.state.spinnerState;
    }
  },
  watch: {
    custIdModalbtn(val) {
      if(val) {
        this.$nextTick(function() {
          const modalEl = document.querySelector('#bp-modal .modal-content');
          const parentWindow = window.parent;
          const that = this;
          setTimeout(function(){
            const maxTop = that.$store.state.appHeight - 650;
            const pwScrollY = parentWindow.scrollY - 200;
            const top = pwScrollY < maxTop ? pwScrollY : maxTop;
            modalEl.style.top = top + 'px';
            if (pwScrollY > maxTop) {
              parentWindow.scrollBy({
                top: (maxTop-pwScrollY),
                left: 0,
                behavior: 'smooth',
              });
            }
          }, 90)
        })
      }
    },
    spinnerState(newState){
      this.states.showMain = !newState;
    }
  }
}
</script>

<style scoped>
.text {
  padding: 0;
}
h2 {
  font-weight: 700;
  margin-bottom: 18px;
}
.dashboard {
  max-width: 940px;
}
.magenta, .magenta a {
  color: #e20074;
}
.mab-2 {
  margin-bottom: 8px;
  margin-top: 18px;
}
input.invalid {
  border-width: 1px 4px;
  border-color: #e20074;
}

input.invalid:focus {
  border-color:#e20074;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
}

</style>
